/* eslint-disable react/no-array-index-key */

import axios from 'axios';
import { quoteFormSelector } from 'ctm-selectors';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styles from './car_preview.css';

/**
 * Render the Car Details component
 * @param {Object} props - the incoming set of props
 * @returns {Node} A component
 */

const _CarPreview = ({ journeyUrl, redbookCode, accessToken }) => {
    const [selectedImage, setSelectedImage] = useState('');
    const [images, setImages] = useState([]);

    useEffect(() => {
        axios({
            method: 'get',
            url: `${journeyUrl}/lookup/manual/${redbookCode}/images`,
            headers: { Authorization: `Bearer ${accessToken}` }

        }).then((response) => { setImages(response.data); setSelectedImage(response.data[0]); });
    }, []);

    if (images.length === 0) {
        return null;
    }

    return (
        <div className={styles.preview_container}>
            <div>
                <img src={selectedImage} alt={''} />
            </div>
            <div className={styles.image_container}>
                { images.map((image, index) => {
                    const isSelected = selectedImage === image;
                    return (
                        <div className={`${styles.image_thumb} ${isSelected ? styles.image_selected : ''}`}
                            key={`car_preview_image_${index}`}
                            role="button"
                            tabIndex={0}
                            onClick={() => setSelectedImage(image)}>
                            <img src={image} alt={''} />
                        </div>
                    );
                }) }
            </div>
            <div className={styles.preview_disclaimer}>Stock image(s) - actual vehicle may differ in style and colour.</div>
        </div>
    );
};

_CarPreview.propTypes = {
    journeyUrl: PropTypes.string.isRequired,
    redbookCode: PropTypes.string.isRequired,
    accessToken: PropTypes.string.isRequired
};

/**
 * Map state to our component props
 * @param {Object} state - the application state
 * @returns {Object} - the set of mapped props for the component
 */
const mapStateToProps = (state) => {
    return {
        journeyUrl: state.getIn(['serverConfig', 'journeyServiceBaseUrl']),
        redbookCode: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'redbookCodeLong']),
        accessToken: state.getIn(['user', 'tokens', 'access_token'])
    };
};

const CarPreview = connect(mapStateToProps)(_CarPreview);

export { CarPreview, _CarPreview };
